<template>
  <div :class="['search', { 'search--visible': visible }]" tabindex="0" @keyup.esc="onClose">
    <div class="search__container">
      <div class="search__head">
        <h1 class="search__head-title">{{ $t('lessonSearch.lesson') }}</h1>
        <div class="d-flex justify-content-end">
          <input v-model="query" v-focus class="search__input" type="text" @keyup.enter="search" />
          <button class="btn search__button" :disabled="!currentQuery" @click="search">
            {{ $t('lessonSearch.search') }}
          </button>
        </div>
        <img class="search__close-icon" src="@/assets/icons/Asset 37.png" @click="onClose" />
      </div>
      <div v-loading="loading" class="search__results">
        <table v-if="lessons.length" class="table table-hover header-fixed">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">{{ $t('singup.grade') }}</th>
              <th scope="col">{{ $t('evaluation.subject') }}</th>
              <th scope="col">{{ $t('lessonSearch.cluster') }}</th>
              <th scope="col">{{ $t('lessonSearch.lesson') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lesson, index) in lessons" :key="lesson.id">
              <td>{{ index + 1 }}</td>
              <td>{{ lesson.grade_name }}</td>
              <td>{{ lesson.subject_name | deleteNumbers }}</td>
              <td>{{ lesson.cluster_name }}</td>
              <td>
                <router-link
                  :to="{
                    name: 'lesson',
                    params: {
                      grade_id: lesson.grade_id,
                      subject_id: lesson.subject_id,
                      cluster_id: lesson.cluster_id,
                      lesson_id: lesson.id,
                    },
                  }"
                  @click.native="onClose"
                  >{{ lesson.name }}</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="notFound" class="search__not-found">
          <h1>{{ $t('lessonSearch.noResultFound') }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "LessonSearch",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lessons: [],
      query: '',
      loading: false,
      notFound: false,
    };
  },
   computed: {
    ...mapGetters({
      currentQuery: 'app/getCurrentQuery',
    }),
  },
  methods: {
    onClose() {
      this.query = '';
      this.$store.commit('app/TOGGLE_DIALOG_LESSON_SEARCH_VISIBLE');
      this.$store.commit('app/SET_CURRENT_QUERY',"");
    },
    search() {
      if (!this.query) {
        return;
      }
      this.notFound = false;
      this.loading = true;
      this.lessons = [];
      this.$httpMain
        .post(`lessons-search`, {
          query: this.query,
          start: 1,
          per_page: 150,
        })
        .then(res => {
          this.lessons = res.data;
        })
        .catch(() => {
          this.notFound = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch:{
    currentQuery(val1,val2){
      this.query= val1;
      this.search();
    }
  }
};
</script>
<style lang="sass" scoped>
.search
  position: fixed
  top: 0
  right: 0
  left: 0
  bottom: 0
  z-index: 1000
  display: none
  +modifier('visible')
    display: block
  +forTablet
    padding: 1em
  +forDesktop
    padding: 5em 3em
  background-color: rgba(64, 157, 164, 0.6)
  +element('head')
    border-top-left-radius: 5px
    background-color: #ced529
    text-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.65)
    height: 110px
    width: 100%
    padding: 10px
    position: relative
    +forTablet
      &:after,
      &:before
        top: 100%
        right: 0
        border: solid transparent
        content: ' '
        height: 0
        width: 0
        position: absolute
        pointer-events: none
        z-index: -1
      &:after
        border-color: rgba(136, 183, 213, 0)
        border-top-color: #838624
        border-width: 30px
        margin-left: -30px
      &:before
        border-color: rgba(194, 225, 245, 0)
        border-top-color: #838624
        border-width: 36px
        margin-left: -36px
    +forTablet
      height: 90px
      display: flex
      align-items: center
      justify-content: space-between
      padding-right: 3em
    +forDesktop
  +element('head-title')
    font-family: 'comfortaabold'
    color: #fff
    margin-bottom: 10px
    +forTablet
      margin-bottom: 0
  +element('close-icon')
    position: absolute
    right: 5px
    top: 5px
    width: 35px
    height: 35px
    cursor: pointer
    &:hover
      transform: scale(1.1)
    +forTablet
      right: -10px
      top: -10px
      width: 40px
      height: 40px
  +element('input')
    width: 100%
    height: 45px
    border-radius: 20px
    font-family: 'comfortaabold'
    border: 2px solid #999999
    font-size: 18px
    color: #000000
    background: url('~@/assets/icons/lupa.svg') no-repeat scroll 5px 2px
    background-color: #fff
    padding-left: 40px
    margin-right: 10px
    &:focus-within
      border: 2px solid #a4a75f
    +forTablet
      width: 400px
      background: url('~@/assets/icons/lupa.svg') no-repeat scroll 350px 2px
      background-color: #fff
  +element('button')
    color: #fff
    background-color: #28a745
    border-color: #28a745
    font-family: 'comfortaabold'
    font-size: 16px
    line-height: 24px
    border-radius: 10px
    &:disabled
      background-color: rgba($color: #000000, $alpha: 0.3)
      border-color: rgba($color: #000000, $alpha: 0.3)
  +element('results')
    min-height: 65vh
    max-height: 75vh
    background-color: #fff
    border-bottom-left-radius: 5px
    border-bottom-right-radius: 5px
    padding: 10px 15px
    overflow-y: auto
    +forTablet
      margin-right: 35px
      min-height: 78vh
      max-height: 83vh
    +forDesktop
      min-height: 70vh
      max-height: 80vh
    &:-webkit-scrollbar
      width: 12px
      border-radius: 10px
      background-color: #b0bfc6
    &:-webkit-scrollbar-thumb
      border-radius: 10px
      background-color: #607d8b
</style>
